import { createSelector, createSlice } from '@reduxjs/toolkit';

export const persistRecentlyViewedObjectIds = ({ recentlyViewedObjectIds }) => {
	localStorage.setItem('recentlyViewedObjectIds', JSON.stringify(recentlyViewedObjectIds));
};

export const getPersistedRecentlyViewedObjectIds = () => {
	const persistedData = localStorage.getItem('recentlyViewedObjectIds');
	if (persistedData) {
		return JSON.parse(persistedData);
	}
	return [];
};

const initialState = {
	all: null,
	recentlyViewedObjectIds: getPersistedRecentlyViewedObjectIds(),
	lastViewedObjectId: null,
};

const objectsSlice = createSlice({
	name: 'objects',
	initialState,
	reducers: {
		setObjects: (state, action) => {
			if (action?.payload?.objects) {
				const { objects } = action.payload; // filter(action.payload.objects, (object) => object.file_type !== 'html');
				state.all = objects;

				// clean recently viewed object Ids
				const recentlyViewedObjectIds = state.recentlyViewedObjectIds.filter((oId) => Object.keys(objects).includes(oId));
				state.recentlyViewedObjectIds = recentlyViewedObjectIds;
			}
		},
		resetObjects: (state) => {
			state.all = initialState.all;
		},
		recentlyViewedObject: (state, action) => {
			const { objectId } = action.payload;
			const recentlyViewedObjectIds = state.recentlyViewedObjectIds.filter((oId) => oId !== objectId);
			recentlyViewedObjectIds.push(objectId);
			state.recentlyViewedObjectIds = recentlyViewedObjectIds;
			state.lastViewedObjectId = objectId;
		},
	},
});

export default objectsSlice.reducer;
export const { setObjects, resetObjects, recentlyViewedObject } = objectsSlice.actions;

export const selectAllObjects = (state) => state.objects.all;
export const selectObjectById = (state, objectId) => state.objects.all?.[objectId];
export const selectObjectsById = (state, objectIds) => objectIds.map((objectId) => state.objects.all?.[objectId]);
export const selectObjectsByFolder = (state, folder) => folder.objects.map((objectId) => state.objects.all?.[objectId]);
export const selectRecentlyViewedObjectIds = (state) => state.objects.recentlyViewedObjectIds;
export const selectLastViewedObjectId = (state) => state.objects.lastViewedObjectId;

export const selectLastViewedObject = createSelector(
	selectLastViewedObjectId,
	selectAllObjects,
	(lastViewedObjectId, allObjects) => allObjects?.[lastViewedObjectId] ?? null,
);

export const selectRecentlyViewedObjects = createSelector(
	selectRecentlyViewedObjectIds,
	selectAllObjects,
	(recentlyViewedObjectIds, allObjects) => (recentlyViewedObjectIds && allObjects ? recentlyViewedObjectIds.map((objId) => allObjects[objId]).filter((entry) => typeof entry !== 'undefined' && entry !== null) : []),
);

export const selectPropertyIdsByFolder = (state, folder) => {
	if (!folder?.objects) {
		return null;
	}
	const propertiesOfObjects = folder.objects.map((objectId) => {
		const object = state.objects.all?.[objectId];
		return object?.properties;
	});
	const flatPropertiesOfObjects = propertiesOfObjects.reduce((a, b) => a.concat(b), []);
	const removeDuplicates = [...new Set(flatPropertiesOfObjects)];
	return removeDuplicates;
};

export const getLinkOfObject = (object) => {
	let url = null;
	if (object.type === 'doc') {
		if (object.file_type !== 'html') {
			if (object.file === '') {
				url = '';
			} else {
				url = `${process.env.REACT_APP_API_BASE_URL}/${object.file}`;
			}
		} else if (object.fallback_link_file && object.fallback_link_file !== '') {
			url = `${object.fallback_link_file}`;
		}
	} else if (object.type === 'MAM') {
		url = `${process.env.REACT_APP_MAM_BASE_URL}${object.file}`;
	} else if (object.type === 'link') {
		url = `${object.link}`;
	}

	return url;
};
